const DEFAULT_INTERNAL_EMAIL_DOMAIN = "anthemcoffeeimports.com";

function normalizeEmail(value: string | null | undefined): string {
  return (value ?? "").trim().toLowerCase();
}

export function isAllowedInternalEmail(email: string | null | undefined): boolean {
  const normalizedEmail = normalizeEmail(email);
  if (!normalizedEmail) return false;

  const atIndex = normalizedEmail.lastIndexOf("@");
  if (atIndex <= 0 || atIndex === normalizedEmail.length - 1) {
    return false;
  }

  const domain = normalizedEmail.slice(atIndex + 1);
  return domain === DEFAULT_INTERNAL_EMAIL_DOMAIN;
}

export function getInternalEmailDomainErrorMessage(): string {
  return `Use your @${DEFAULT_INTERNAL_EMAIL_DOMAIN} email to access the internal portal.`;
}
